import React from "react";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";

// Shown when the notes form is closed while a scene stopwatch is still running.
export default function TimerCloseConfirm({ open, onCancel, onConfirm }) {
  return (
    <AlertDialog open={open} onOpenChange={(o) => !o && onCancel()}>
      <AlertDialogContent data-testid="notes-timer-close-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle className="font-heading">A scene timer is still running</AlertDialogTitle>
          <AlertDialogDescription>Closing the form stops the timer and discards any changes you haven't saved.</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className="rounded-full" data-testid="notes-timer-keep-btn">Keep timing</AlertDialogCancel>
          <AlertDialogAction className="rounded-full bg-red-600 hover:bg-red-700" onClick={onConfirm} data-testid="notes-timer-close-confirm">Close anyway</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
